const homeEducationSection = $('#education-section');
const educationCards = homeEducationSection.find('.education-descriptor-card-placer');
const educationBtn = homeEducationSection.find('.button-parent');
const educationCardOffset = isDesktop() ? 3.333 : 9.375;
const educationBtnOffset = isDesktop() ? 3.333 : 4.688;
let topOffset;

function changeBtn(btn, newText, link) {
  const btnParentSection = btn.closest('section');
  const btnTextOverflow = btn.find('.button-text-overflow');
  const currentBtnText = btn.find('.button-text');
  const currentLink = btn.attr('href');
  const toBtnText = $('<p>', { class: 'button-text font-primary-link' }).text(newText);
  btnTextOverflow.append(toBtnText);
  toBtnText.css('display', 'none');

  const changeBtnTL = gsap.timeline({ paused: true });
  changeBtnTL.addLabel('step1');

  changeBtnTL.add(
    gsap.fromTo(
      currentBtnText,
      { opacity: 1 },
      {
        opacity: 0,
        duration: 0.33,
        overwrite: 'auto',
      }
    ),
    'step1'
  );

  changeBtnTL.add(
    gsap.fromTo(
      btnTextOverflow,
      {
        width: () => `${pxToVw(currentBtnText.outerWidth())}vw`,
      },
      {
        width: 0,
        duration: 0.533,
        ease: 'pageInEasing',
        overwrite: 'auto',
        onComplete: () => {
          currentBtnText.css('display', 'none');
          toBtnText.css('display', 'block');
          btn.attr('href', link);
        },
      }
    ),
    'step1'
  );

  changeBtnTL.addLabel('step2');

  changeBtnTL.add(
    gsap.fromTo(
      btnTextOverflow,
      {
        width: 0,
      },
      {
        width: () => `${pxToVw(toBtnText.outerWidth())}vw`,
        duration: 0.533,
        ease: 'pageInEasing',
        overwrite: 'auto',
        onReverseComplete: () => {
          currentBtnText.css('display', 'block');
          toBtnText.css('display', 'none');
          btn.attr('href', currentLink);
        },
      }
    ),
    'step2'
  );

  changeBtnTL.add(
    gsap.fromTo(
      toBtnText,
      { opacity: 0 },
      {
        opacity: 1,
        duration: 0.33,
        overwrite: 'auto',
      }
    ),
    'step2+=0.2'
  );

  return changeBtnTL;
}

const educationCardIn = (cardIndex, duration) => {
  const currCard = educationCards.eq(cardIndex);
  const cardHeight = pxToVw(currCard.outerHeight());
  const currCardOffset = educationCardOffset * cardIndex;
  const cardLine = currCard.find('.descriptor-title-line');
  const cardContent = currCard.find('.descriptor-title, .descriptor-bottom');
  const cardTL = gsap.timeline({ paused: true });
  cardTL.add(
    gsap.fromTo(
      currCard,
      {
        top: '100%',
      },
      {
        top: `${currCardOffset}vh`,
        duration: duration,
      }
    ),
    0
  );
  cardTL.add(
    gsap.fromTo(
      cardLine,
      {
        width: '0%',
      },
      {
        width: '100%',
        duration: duration,
      }
    ),
    0
  );
  cardTL.add(
    gsap.fromTo(
      cardContent,
      {
        opacity: 0,
        y: '2vw',
      },
      {
        opacity: 1,
        y: 0,
        duration: duration,
      }
    ),
    0
  );

  return cardTL;
};

const educationScrollAnimation = (duration, pause) => {
  const scrollTL = gsap.timeline({ paused: true });
  scrollTL.addLabel('pause', 0);
  educationCards.each(function (i) {
    scrollTL.addLabel(`step${i}`, duration * i + pause);
    if (i == 0) {
      scrollTL.add(
        changeBtn(educationBtn, 'Educational resources', '/pages/educator-students', 18.25).play(),
        `step${i}+=0.1`
      );
    } else {
      scrollTL.add(educationCardIn(i, duration).play(), `step${i}`);
    }
  });

  return scrollTL;
};

const educationInAnimation = () => {
  const educationTL = gsap.timeline({ paused: true });
  const animationInConfig = {
    title: {
      offsetPercent: 200,
      opacityStart: 0,
      blurStart: '0px',
      duration: 1.2,
      delay: 0.3,
      stagger: 0.066,
      isDurationCommon: true,
    },
  };

  educationTL.add(
    animateSectionTopperIn({
      sectionParent: homeEducationSection,
      titleStagger: 0.198,
      animationInConfig: animationInConfig,
    }).play(),
    0
  );

  educationTL.add(educationCardIn(0, 0.883).play(0), 0.6);
  educationTL.add(addBtnAnimation(educationBtn, 60, 18.25).play(), 0.7);

  return educationTL;
};

const setScrollerTopOffset = () => {
  const educationScroller = homeEducationSection.find('.education-section-scroller');
  const educationContent = homeEducationSection.find('.education-section-content');
  const educationTopper = homeEducationSection.find('.education-section-topper');
  const educationTopperHeight = pxToVh(educationTopper.outerHeight());
  const educationCardHeight = pxToVh(educationCards.outerHeight());
  const educationBtnHeight = pxToVh(educationBtn.outerHeight());
  const educationContentMarginTop = pxToVh(educationContent.css('margin-top').replace('px', ''));
  const elementsHeight = educationCardHeight + educationBtnHeight;
  const offsetsHeight =
    educationContentMarginTop + educationBtnOffset + educationCardOffset * (educationCards.length - 1);
  const educationContentHeight = elementsHeight + offsetsHeight;
  educationContent.css('height', `${educationContentHeight}vh`);
  const educationScrollerHeight = pxToVh(educationScroller.outerHeight());
  topOffset = 100 - educationContentHeight - educationTopperHeight;
  educationScroller.css('top', `${100 - educationScrollerHeight}vh`);
};

setScrollerTopOffset();
$(window).on('resize', () => {
  setScrollerTopOffset();
});

const educationTrigger = () => {
  let scrollTL = educationScrollAnimation(0.667, 0.3);
  const educationTL = isDesktop() ? educationInAnimation() : false;

  $(window).on('deviceChange', function () {
    const progress = scrollTL.progress();
    scrollTL = educationScrollAnimation(0.667, 0.3);
    scrollTL.progress(progress);
  });

  ScrollTrigger.create({
    trigger: homeEducationSection,
    start: `top top+=70%`,
    end: 'top+=20% top',
    once: true,
    onUpdate: (self) => {
      //educationTL.progress(self.progress);
    },
    onEnter: () => {
      educationTL ? educationTL.play() : false;
    },
  });
  ScrollTrigger.create({
    trigger: homeEducationSection,
    start: `top+=20% top`,
    end: 'bottom bottom',
    onUpdate: (self) => {
      const progress = self.progress;
      scrollTL.progress(progress);
    },
  });
};

/*
$(window).on('heroReady', function () {
educationTrigger();
});
*/

addSectionObserver(homeEducationSection, educationTrigger);
